import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=0c7f7df8&scoped=true&"
import script from "./UploadDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=0c7f7df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f7df8",
  null
  
)

export default component.exports